import React, { JSX } from "react";
import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { MetaInterface } from "../../../common/interfaces/MetaInterface";
import { Dispatch } from "redux";
import {
    getEmployeeInactiveCertificateCardHeaderAction,
    getEmployeeInactiveCertificateCardMetadata,
} from "../utils/getEmployeeInactiveCertificateCardData";

interface Props {
    certificatesData?: {
        data: CertificateInterface[];
        meta?: MetaInterface;
    };
    isLeftTagOpenIndex: number | null;
    isRightTagOpenIndex: number | null;
    leftTagRef: React.RefObject<HTMLDivElement | null>;
    rightTagRef: React.RefObject<HTMLDivElement | null>;
    dispatch: Dispatch;
}

export const EmployeeInactiveCertificates = (props: Props): JSX.Element => {
    const {
        certificatesData,
        isLeftTagOpenIndex,
        isRightTagOpenIndex,
        leftTagRef,
        rightTagRef,
        dispatch,
    } = props;

    return (
        <div className={"p-employee-inactive__content__certificates"}>
            {certificatesData?.data.map((certificate) => (
                <DetailCard
                    key={certificate.id}
                    className={
                        "p-employee-inactive__content__certificates__card"
                    }
                    title={certificate.qualification.name}
                    headerAction={getEmployeeInactiveCertificateCardHeaderAction(
                        certificate,
                    )}
                    metadata={getEmployeeInactiveCertificateCardMetadata({
                        certificate,
                        dispatch,
                        isLeftTagOpenIndex,
                        isRightTagOpenIndex,
                        leftTagRef,
                        rightTagRef,
                    })}
                />
            ))}
        </div>
    );
};
